<template>
  <label :name="systemName + '-label'" :for="systemName" class="block text-black mt-2">
    {{ label }}
  </label>
  <input
    :id="systemName"
    :name="systemName"
    :type="type"
    v-bind="$attrs"
    :placeholder="placeholder || label"
    class="w-full px-4 py-3 mt-1 bg-gray-100 border rounded-sm field focus:outline-none"
    :class="{ 'border-red-800': error }"
    :value="modelValue"
    :aria-describedby="error ? `${systemName}-error` : ''"
    :aria-invalid="error ? true : false"
    :disabled="disabled"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
  />
  <p
    :id="`${systemName}-error`"
    class="text-red-800"
    v-show="error"
    aria-live="assertive"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { ToSystemName } from "../helpers";

//const uuid = UniqueId().getId();

const props = withDefaults(
  defineProps<{
    label?: string;
    modelValue?: string | number;
    error?: string;
    type?: string;
    placeholder?: string;
    disabled?: boolean;
  }>(),
  {
    label: "",
    modelValue: "",
    error: "",
    type: "text",
    placeholder: "",
    disabled: false,
  }
);

const systemName = ToSystemName(props.label);
</script>
